import Vue from "vue";
import Router from "vue-router";
import axios from "axios";

import AreaExternaLayout from "@/views/Layout/AreaExternaLayout.vue";
import AreaLogadaLayout from "@/views/Layout/AreaLogadaLayout.vue";

const Home = () => import("@/views/Home.vue");
const Sair = () => import("@/views/Sair.vue");
const Login = () => import("@/views/Login.vue");
const EsqueciSenha = () => import("@/views/EsqueciSenha.vue");
const Cadastro = () => import("@/views/Cadastro.vue");
const TrocaSenha = () => import("@/views/TrocaSenha.vue");
const MeusDados = () => import("@/views/MeusDados.vue");
const UsuarioLead = () => import("@/views/UsuarioLead.vue");
const LogAuditoria = () => import("@/views/LogAuditoria.vue");
const Estrutura = () => import("@/views/Estrutura.vue");
const ProjetoPainel = () => import("@/views/ProjetoPainel.vue");
const ProjetoPainelSimulacao = () => import("@/views/ProjetoPainelSimulacao.vue");
const TipoAtividade = () => import("@/views/TipoAtividade.vue");
const Mensagem = () => import("@/views/Mensagem.vue");
const ProjetoCadastro = () => import("@/views/ProjetoCadastro.vue");
const ProjetoValidacao = () => import("@/views/ProjetoValidacao.vue");
//const ProjetoTimeline = () => import("@/views/ProjetoTimeline.vue");
const ProjetoPendente = () => import("@/views/ProjetoPendente.vue");
const ProjetoListagem = () => import("@/views/ProjetoListagem.vue");
const AtividadeListagem = () => import("@/views/AtividadeListagem.vue");
const AtividadeCadastro = () => import("@/views/AtividadeCadastro.vue");
const Portifolio = () => import("@/views/Portifolio.vue");
const Notificacao = () => import("@/views/Notificacao.vue");
const Kanban = () => import("@/views/Kanban.vue");
const OkrMonitoramento = () => import("@/views/OkrMonitoramento.vue");
const OkrCadastro     = () => import("@/views/OkrCadastro.vue");

let rotasHome = {
  path: "/home",
  component: AreaLogadaLayout,
  redirect: "/home",
  name: "Home",
  children: [
    {
      path: "/",
      component: Home,
    },
    {
      path: "/sair",
      component: Sair,
    },
  ],
};

let rotasLogin = {
  path: "/login",
  component: AreaExternaLayout,
  redirect: "/login",
  name: "Login",
  children: [
    {
      path: "/",
      component: Login,
    },
    {
      path: "esqueci-senha",
      component: EsqueciSenha,
    },
    {
      path: "cadastro",
      component: Cadastro,
    },
  ],
};

let rotasKanban = {
	path: "/kanban",
	component: AreaLogadaLayout,
	redirect: "/kanban",
	name: "Kanban",
	children: [
		{
			path: "/",
			component: Kanban,
		},
	],
};

let rotasMeuPerfil = {
  path: "/meuperfil",
  component: AreaLogadaLayout,
  redirect: "/meuperfil",
  name: "Meuperfil",
  children: [
    {
      path: "trocasenha",
      component: TrocaSenha,
    },
    {
      path: "meusdados",
      component: MeusDados,
    },
  ],
};

let rotasUsuarioLead = {
  path: "/lead",
  component: AreaLogadaLayout,
  redirect: "/lead",
  name: "UsuarioLead",
  children: [
    {
      path: "/",
      component: UsuarioLead,
    },
  ],
};

let rotasLogAuditoria = {
  path: "/log",
  component: AreaLogadaLayout,
  redirect: "/log",
  name: "LogAuditoria",
  children: [
    {
      path: "/",
      component: LogAuditoria,
    },
  ],
};

let rotasEstrutura = {
  path: "/estrutura",
  component: AreaLogadaLayout,
  redirect: "/estrutura",
  name: "Estrutura",
  children: [
    {
      path: "/",
      component: Estrutura,
    },
  ],
};

let rotasTipoAtividade = {
  path: "/tipo-atividade",
  component: AreaLogadaLayout,
  redirect: "/tipo-atividade",
  name: "TipoAtividade",
  children: [
    {
      path: "/",
      component: TipoAtividade,
    },
  ],
};

let rotasProjetoPainel = {
  path: "/painel",
  component: AreaLogadaLayout,
  redirect: "/painel",
  name: "ProjetoPainel",
  children: [
    {
      path: "/",
      component: ProjetoPainel,
    },
  ],
};

let rotasProjetoPainelSimulacao = {
  path: "/painel-simulacao",
  component: AreaLogadaLayout,
  redirect: "/painel-simulacao",
  name: "ProjetoPainelSimulacao",
  children: [
    {
      path: "/",
      component: ProjetoPainelSimulacao,
    },
  ],
};

let rotasMensagem = {
  path: "/mensagem",
  component: AreaLogadaLayout,
  redirect: "/mensagem",
  name: "Mensagem",
  children: [
    {
      path: "/",
      component: Mensagem,
    },
    {
      path: ':rem/:dest',
      props: true,
      component: Mensagem
    }
  ],
};

let rotasProjetoCadastro = {
  path: "/projeto-cadastro",
  component: AreaLogadaLayout,
  redirect: "/projeto-cadastro",
  name: "ProjetoCadastro",
  children: [
    {
      path: "/",
      component: ProjetoCadastro,
    },
    {
      path: ":idprojeto",
      props: true,
      component: ProjetoCadastro,
    },
  ],
};

let rotasProjetoValidacao = {
  path: "/projeto-validacao",
  component: AreaLogadaLayout,
  redirect: "/projeto-validacao",
  name: "ProjetoValidacao",
  children: [
    {
      path: "/",
      component: ProjetoValidacao,
    },
  ],
};

/*
let rotasProjetoTimeline = {
  path: "/projeto-timeline",
  component: AreaLogadaLayout,
  redirect: "/projeto-timeline",
  name: "ProjetoTimeline",
  children: [
    {
      path: ":idProjeto",
      props: true,
      component: ProjetoTimeline,
    },
  ],
};
*/

let rotasProjetoPendente = {
  path: "/projeto-pendente",
  component: AreaLogadaLayout,
  redirect: "/projeto-pendente",
  name: "ProjetoPendente",
  children: [
    {
      path: "/",
      component: ProjetoPendente,
    },
  ],
};

let rotasProjetoListagem = {
  path: "/projeto-listagem",
  component: AreaLogadaLayout,
  redirect: "/projeto-listagem",
  name: "ProjetoListagem",
  children: [
    {
      path: "/",
      component: ProjetoListagem,
    },
  ],
};

let rotasAtividadeListagem = {
  path: "/atividade-listagem",
  component: AreaLogadaLayout,
  redirect: "/atividade-listagem",
  name: "AtividadeListagem",
  children: [
    {
      path: "/",
      component: AtividadeListagem,
    },
  ],
};

let rotasAtividadeCadastro = {
  path: "/atividade-cadastro",
  component: AreaLogadaLayout,
  redirect: "/atividade-cadastro",
  name: "AtividadeCadastro",
  children: [
    {
      path: "/",
      component: AtividadeCadastro,
      children: [
        {
          path: "projeto/:idprojeto",
          props: true,
          component: AtividadeCadastro,
        }
      ]
    },
    {
      path: ":idatividade",
      props: true,
      component: AtividadeCadastro,
    },
  ],
};

let rotasPortifolio = {
  path: "/portifolio",
  component: AreaLogadaLayout,
  redirect: "/portifolio",
  name: "Portifolio",
  children: [
    {
      path: "/",
      component: Portifolio,
    }
  ]
};

let rotasNotificacao = {
  path: "/notificacao",
  component: AreaLogadaLayout,
  redirect: "/notificacao",
  name: "Notificacao",
  children: [
    {
      path: "/",
      component: Notificacao,
    }
  ]
};

let rotasOkr = {
  path: "/okr",
  component: AreaLogadaLayout,
  redirect: "/okr",
  name: "Okr",
  children: [
    {
      path: "/okr",
      component: OkrMonitoramento,
    },
    {
      path: "/okr-cadastro",
      component: OkrCadastro,
    },
    {
      path: "/okr-cadastro/:idokr",
      component: OkrCadastro,
      props: true,
    },
  ],
};

const routes = [
  rotasLogin,
  rotasMeuPerfil,
  rotasEstrutura,
  rotasProjetoPainel,
  rotasProjetoPainelSimulacao,
  rotasTipoAtividade,
  rotasUsuarioLead,
  rotasLogAuditoria,
  rotasMensagem,
  rotasProjetoCadastro,
  rotasProjetoValidacao,
  //rotasProjetoTimeline,
  rotasProjetoPendente,
  rotasProjetoListagem,
  rotasAtividadeListagem,
  rotasAtividadeCadastro,
  rotasPortifolio,
  rotasNotificacao,
  rotasKanban,
  rotasOkr,
  rotasHome,
  {
    path: "*",
    redirect: "/home",
  },
];

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

router.beforeResolve((to, from, next) => {
	if (
		to.path == "/" ||
		to.path == "/login" ||
		to.path == "/login/esqueci-senha" ||
		to.path == "/login/cadastro"
	) {
    localStorage.removeItem("token")
    sessionStorage.removeItem("token")
    localStorage.removeItem("trocaPerfil")
		next();
	} else {
		axios.get(process.env.VUE_APP_API_URL + "/user/dados", {
			headers: { 
				token: sessionStorage.getItem("token") || localStorage.getItem("token"),
				trocaPerfil: localStorage.getItem("trocaPerfil")
			}
		})
		.then((response) => {
			localStorage.setItem("nome", response.data.object.nome);
			localStorage.setItem("avatar", response.data.object.avatar);
			localStorage.setItem("idusuario", response.data.object.idusuario);
			localStorage.setItem("pid", response.data.object.profileId);
			localStorage.setItem("pnome", response.data.object.profile);
			localStorage.setItem("pdescricao", response.data.object.profileDescricao);
			next();
		})
		.catch(() => {
			next("/login");
		});
	}
});

export default router;
